import React from 'react';
import { createSiteChromeLayout } from '@noths/polaris-client-site-chrome-ui';
import cookies from 'js-cookie';

import type { SiteChromeLayoutComponentProps } from '../types';

const SiteChromeLayout = createSiteChromeLayout('#NOTHSPageWrapper');

export const ClientSiteChromeUI = ({
  children,
  enableCurator,
  isProdLikeEnv,
  mergeBasket,
  searchedTerm,
  siteChromeCompactMode = false,
  siteChromeContent,
  stickyTopBanner = false,
}: SiteChromeLayoutComponentProps) => (
  <SiteChromeLayout
    compact={siteChromeCompactMode}
    cookies={cookies}
    enableCurator={enableCurator}
    env={isProdLikeEnv ? 'production' : 'qa'}
    mergeBasket={mergeBasket}
    searchedTerm={searchedTerm}
    siteChromeContent={siteChromeContent}
    stickyTopBanner={stickyTopBanner}
  >
    {children}
  </SiteChromeLayout>
);
